<template>
  <div>
    <review stage="1" auditType="2" />
  </div>
</template>

<script>
  import review from './review'
  export default {
    name: "auditReview",
    components:{review},
  }
</script>